<template>
  <div class="special-column-item">
    <div class="head f-b-c">
      <div>
        <div class="title">{{ $t(column.title) }}</div>
        <div class="subhead ellipsis" v-for="(t, i) in column.subhead" :key="i">{{ $t(t) }}</div>
      </div>
      <slot />
    </div>

    <div class="column-list f-b-c">
			<div v-for="(item ,i) in column.list" :key="i" class="img">
        <oss-img :src="item.url" :width="196" :height="196" />
			</div>
		</div>
  </div>
</template>

<script>
import OssImg from '../../../components/OssImg.vue'
export default {
  components: { OssImg },
  props: {
    column: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.special-column-item {
	background-color: #fff;
	border-radius: 12px;
	padding: 26px 24px;

  .head {

    .title {
      font-weight: 600;
      font-size: 30px;
      line-height: 30px;
      margin-bottom: 10px;
    }

    .subhead {
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
    }
  }

	.column-list {
		// height: 196px;
		margin-top: 14px;

		.img {
			width: 31%;
      height: 100%;
      border-radius: 12px;
      overflow: hidden;

			img {
        display: block;
				object-fit: cover;
        border-radius: 12px;
			}
		}
	}

  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
